// material-ui
import { styled } from "@mui/material/styles";
import LinearProgress from "@mui/material/LinearProgress";
import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles(() => ({
  root: {
    "& .MuiLinearProgress-barColorPrimary": {
      backgroundColor: "#ffffff", // progress bar color
    },
  },
}));

// ==============================|| Full-Screen Overlay Loader ||============================== //

const LoaderOverlay = styled("div")(({ theme }) => ({
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100vh",
  zIndex: 2001,
  backgroundColor: "rgba(0, 0, 0, 0.4)", // semi-transparent overlay
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
}));

const LoadingText = styled("div")(({ theme }) => ({
  marginTop: theme.spacing(2),
  color: "#fff",
  fontWeight: 500,
  fontSize: "1.1rem",
}));

export const Loader = ({ text = "Loading..." }) => {
  const classes = useStyles();

  return (
    <LoaderOverlay className={classes.root}>
      <LinearProgress
        sx={{
          width: "60%",
          borderRadius: "4px",
          height: "6px",
          backgroundColor: "rgba(255,255,255,0.2)",
        }}
      />
      <LoadingText>{text}</LoadingText>
    </LoaderOverlay>
  );
};

// ==============================|| Table Loader (Top Progress Bar) ||============================== //

const TableLoaderWrapper = styled("div")(({ theme }) => ({
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  zIndex: 1000,
  backgroundColor: theme.palette.primary.main,
}));

export const TableLoader = () => {
  const classes = useStyles();
  return (
    <TableLoaderWrapper className={classes.root}>
      <LinearProgress />
    </TableLoaderWrapper>
  );
};

export default Loader;
